// --- 基地综合管理 --- //

export default [
  {
    name: 'baseList',
    path: '/supplySystem/:supplyId/baseManagement/baseList',
    meta: { title: '基地列表' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseList/list.vue').default
  },
  {
    name: 'maintainData',
    path: '/supplySystem/:supplyId/baseManagement/baseList/maintainData',
    meta: { title: '生产数据维护' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseList/maintainData.vue').default
  },
  {
    name: 'baseProductionTotalData',
    path: '/supplySystem/:supplyId/baseManagement/baseProductionData',
    meta: { title: '基地生产数据' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseProductionData/list.vue').default
  },
  {
    name: 'baseCultivationData',
    path: '/supplySystem/:supplyId/baseManagement/baseCultivationData',
    meta: { title: '基地养殖数据' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseCultivationData/list.vue').default
  },
  {
    name: 'baseStatistics',
    path: '/supplySystem/:supplyId/baseManagement/baseStatistics',
    meta: { title: '基地数据统计' },
    component: require('business/supplySystem/baseSyntheticalManagement/baseStatistics/list.vue').default
  }
]
